import { render, staticRenderFns } from "./issueCardTeam.vue?vue&type=template&id=17809608&scoped=true&"
import script from "./issueCardTeam.vue?vue&type=script&lang=ts&"
export * from "./issueCardTeam.vue?vue&type=script&lang=ts&"
import style0 from "./issueCardTeam.vue?vue&type=style&index=0&id=17809608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17809608",
  null
  
)

export default component.exports